import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { pdfjs } from "react-pdf";
import { useHistory, useLocation } from "react-router-dom";
import PdfModal from "../../components/pdf/PdfModal";
import "./coinExperts.css";
import PdfSuccessionInternationale from "../../medias/avis/CDE 01 pour SD.pdf";
import PdfSuccessionInternationale2 from "../../medias/avis/CDE 02 pour SD.pdf";
import PdfSuccessionInternationale3 from "../../medias/avis/CDE 05 pour SD.pdf";
import PdfDonataireHandicape from "../../medias/avis/CDE 03 pour SD.pdf";
import PdfTVAImmobiliere from "../../medias/avis/CDE 04 pour SD.pdf";
import PdfFamille1 from "../../medias/avis/pma_ou_amp.pdf";
import PdfFamille2 from "../../medias/avis/liquidation_participation_aux_acquets.pdf";
import PdfFamille3 from "../../medias/avis/emoluments_de_formalites_principes_generaux_et_zoom.pdf";
import PdfFamille4 from "../../medias/avis/impact_des_recompenses_assiette_de_emolument_acte.pdf";
import PdfFamille5 from "../../medias/avis/Licitations_rappel_principes_applicables_cas_particuliers.pdf";
import PdfFamille6 from "../../medias/avis/partage_biens_indivis_et_communaute.pdf";
import PdfFamille7 from "../../medias/avis/partage_de_succession.pdf";
import PdfFamille8 from "../../medias/avis/donation_partage.pdf";
import PdfFamille9 from "../../medias/avis/comparatif_entre_licitation_et_partage.pdf";
import PdfFamille10 from "../../medias/avis/calcul_assiette_des_droits_enregistrement_en_presence_de_frais_acte_deductibles.pdf";
import PdfImmobilier1 from "../../medias/avis/liquidation_CSI_dans_donation_demembree_bien_immobilier.pdf";
import PdfImmobilier2 from "../../medias/avis/emoluments_de_formalites_principes_generaux_et_zoom.pdf";
import PdfImmobilier3 from "../../medias/avis/Licitations_rappel_principes_applicables_cas_particuliers.pdf";
import PdfDivers1 from "../../medias/avis/reforme_droit_des_suretes_et_frais_actes_notaries.pdf";
import PdfDivers2 from "../../medias/avis/translation_hypotheque.pdf";
import CdeGuenifey1 from "../../medias/avis/CDE Guénifey 1 SD.pdf";
import CdeGuenifey2 from "../../medias/avis/CDE Guénifey 2 SD.pdf";
import CdeGuenifey3 from "../../medias/avis/CDE Guénifey 3 SD.pdf";
import CdeGuenifey4 from "../../medias/avis/CDE Guénifey 4 SD.pdf";
import Cde06Pdf from "../../medias/avis/CDE 06 pour SD.pdf";
import Cde07Pdf from "../../medias/avis/CDE 07 pour SD.pdf";

const FILTERS = {
  famille: "Famille",
  immobilier: "Immobilier",
  divers: "Divers",
};
const INITIAL_VISIBLE = 3;

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const familySections = [
  {
    title: "Actu patrimoniale",
    collapsible: true,
    items: [
      {
        date: "sept. 2026",
        label: (
            <span>
            Lorsqu'un <strong>héritier renonçant a reçu une donation dans les 15 ans précédant le décès du donateur,</strong>{" "}
            faut il <strong>en tenir compte pour calculer les droits</strong> dus de succession par ses représentants?{" "}
          </span>
        ),
        pdfUrl: Cde06Pdf,
      },
      {
        date: "juillet 2026",
        label: (
          <span>
            Lorsqu'<strong>un héritier a recelé des actifs successoraux</strong> et que{" "}
            <strong>la créance correspondante est irrécouvrable,</strong> doit-elle être{" "}
            <strong>incluse dans l’assiette des émoluments du notaire</strong> afférents à l’acte de partage ?{" "}
          </span>
        ),
        pdfUrl: PdfSuccessionInternationale3,
      },
      {
        date: "mai 2026",
        label: (
          <span>
            Lorsqu’un <strong>donataire</strong> est frappé d’un <strong>handicap l’empêchant de travailler dans des conditions normales</strong> de rentabilité, l’
            <strong>application de l’abattement</strong> de 159 325 euros peut-elle <strong>se présumer ou s’effectuer par priorité à l’abattement en ligne directe</strong> ?
          </span>
        ),
        pdfUrl: PdfDonataireHandicape,
      },
      {
        date: "avril 2026",
        label: (
          <span>
            <strong>L'industrie personnelle</strong> d'un époux entre-t-elle dans le cadre de sa{" "}
            <strong>contribution aux charges du mariage</strong> lorsque celui-ci a réalisé des{" "}
            <strong>travaux logement</strong> familial ?{" "}
          </span>
        ),
        pdfUrl: PdfSuccessionInternationale2,
      },
      {
        date: "mars 2026",
        label: (
          <span>
            Lorsqu'une <strong>déclaration de succession</strong>, devant être{" "}
            <strong>déposée en France,</strong> inclut des éléments d'
            <strong>actif situés à l'étranger</strong> faisant par ailleurs l'objet d'une{" "}
            <strong>déclaration fiscale</strong> dans un autre pays, l'
            <strong>émolument</strong> doit-il avoir pour base le{" "}
            <strong>patrimoine mondial</strong> ou le seul{" "}
            <strong>patrimoine français</strong> ?
          </span>
        ),
        pdfUrl: PdfSuccessionInternationale,
      },
      {
        date: "février 2026",
        label: (
          <span>
            <strong>La renonciation à succession</strong> par le{" "}
            <strong>conjoint survivant</strong> entraîne-t-elle également{" "}
            <strong>renonciation</strong> au bénéfice d'une{" "}
            <strong>donation entre époux</strong> ?
          </span>
        ),
        pdfUrl: CdeGuenifey2,
      },
      {
        date: "janvier 2026",
        label: (
          <span>
            Qui doit <strong>recevoir les capitaux-décès d'assurance-vie</strong> lorsque le{" "}
            <strong>bénéficiaire décède avant d'avoir accepté</strong> le bénéfice du contrat à son profit ?
          </span>
        ),
        pdfUrl: CdeGuenifey1,
      },
    ],
  },
  {
    title: "Avis d'experts - Taxe",
    collapsible: true,
    items: [
      {
        date: "2026",
        label: (
          <span>
            La <strong>Procréation Médicalement Assistée</strong> (PMA) ou Assistance Médicale à la
            Procréation (AMP) : <strong>quelle taxe pour quel acte ?</strong>
          </span>
        ),
        pdfUrl: PdfFamille1,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Liquidation d'Une Participation aux Acquêts</strong> : Principes Applicables à
            l'<strong>Émolument d'Acte</strong>
          </span>
        ),
        pdfUrl: PdfFamille2,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Les Émoluments de Formalités</strong> : Principes Généraux et Zoom Sur le
            <strong> N° 204</strong> du <strong>Tableau 5</strong>
          </span>
        ),
        pdfUrl: PdfFamille3,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>L'Impact</strong> des Récompenses Dans <strong> L’Assiette </strong>de l'Émolument d'Acte
          </span>
        ),
        pdfUrl: PdfFamille4,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Les Licitations :</strong>Rappel des Principes Applicables et Cas Particuliers
          </span>
        ),
        pdfUrl: PdfFamille5,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Partage de Biens Indivis et de Communauté :</strong> Calcul de l’Émolument d’Acte
          </span>
        ),
        pdfUrl: PdfFamille6,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Partage de Succession :</strong> Focus sur <strong>l’Émolument d’Acte</strong> et le <strong>Droit de Partage</strong>
          </span>
        ),
        pdfUrl: PdfFamille7,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Donation-partage :</strong> Quelques Points Sous Forme de <strong>Questions / Réponses</strong>
          </span>
        ),
        pdfUrl: PdfFamille8,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Indivision :</strong> Tableau Comparatif Entre <strong>Licitation</strong> et <strong>Partage</strong>
          </span>
        ),
        pdfUrl: PdfFamille9,
      },
      {
        date: "2026",
        label: (
          <span>
            Le Calcul de <strong>L’Assiette des Droits d'Enregistrement</strong> en Présence 
            de Frais d’Acte Déductibles
          </span>
        ),
        pdfUrl: PdfFamille10,
      },
      
    ],
  },
];

const immobilierSections = [
  {
    title: "Actu patrimoniale",
    collapsible: false,
    items: [
      {
        date: "oct. 2026",
        label: (
          <span>
            Comment le <strong>rapport successoral</strong> doit-il s’exercer lorsque la <strong>donation</strong>{" "}
            <strong>d’argent</strong> donnée a permis la <strong>souscription de titres de société</strong> ?{" "}
          </span>
        ),
        pdfUrl: CdeGuenifey4,
      },
      {
        date: "oct. 2026",
        label: (
          <span>
            Lorsque deux acquéreurs deviennent <strong>propriétaires de leur résidence</strong>{" "}
            <strong>principale en indivision</strong> ou <strong>pour le compte de la communauté</strong> existant{" "}
            entre eux, dans quelles hypothèses est-il possible de <strong>ne pas appliquer{" "}
            la hausse du taux de droits de mutation à titre onéreux</strong> ?{" "}
          </span>
        ),
        pdfUrl: Cde07Pdf,
      },
      {
        date: "août 2026",
        label: (
            <span>
            <strong>Lorsqu’un bien reçu par succession est vendu, comment déterminer le prix d’acquisition ?</strong>
          </span>
        ),
        pdfUrl: CdeGuenifey3,
      },
      {
        date: "juin 2026",
        label: (
          <span>
            Lorsqu’un bien était achevé depuis <strong>moins de 5 ans au jour du compromis de vente</strong> mais l’est depuis 
            <strong>plus de 5 ans au jour de la réitération, la vente entre-t-elle ou non dans le champ de la TVA immobilière</strong> ?
          </span>
        ),
        pdfUrl: PdfTVAImmobiliere,
      },
    ],
  },
  {
    title: "Avis d'experts - Taxe",
    collapsible: false,
    items: [
      {
        date: "2026",
        label: (
          <span>
            La <strong>Liquidation de la CSI</strong> Dans Une
            <strong> Donation Démembrée d'un Bien Immobilier</strong>
          </span>
        ),
        pdfUrl: PdfImmobilier1,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Les Émoluments de Formalités</strong> - Principes Généraux  
            et Zoom sur le n° 204 du Tableau 5
          </span>
        ),
        pdfUrl: PdfImmobilier2,
      },
      {
        date: "2026",
        label: (
          <span>
            <strong>Les Licitations</strong> : Rappel des Principes Applicables 
            et Cas Particuliers
          </span>
        ),
        pdfUrl: PdfImmobilier3,
      },
    ],
  },
  
];

const diversSections = [
  {
    title: "Actu patrimoniale",
    collapsible: false,
    items: [
      { date: "", label: <span>Aucun avis disponible pour le moment</span>, disabled: true },
    ],
  },

  {
    title: "Avis d'experts - Taxe",
    collapsible: false,
    items: [
      { 
        date: "2026",
        label: (
          <span>
            <strong>La Réforme du Droit des Sûretés</strong> et les Frais d’Actes Notariés
          </span>
        ),
        pdfUrl: PdfDivers1,
      },
      { 
        date: "2026", 
        label: (
          <span>
            <strong>La Translation d’Hypothèque</strong>
          </span>
        ),
        pdfUrl: PdfDivers2,
      },
    ],
  },
];
function PlusIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" aria-hidden="true">
      <path d="M15 7 H21 V15 H29 V21 H21 V29 H15 V21 H7 V15 H15 Z" fill="currentColor" />
    </svg>
  );
}
function MinusIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" aria-hidden="true">
      <path d="M7 15 H29 V21 H7 Z" fill="currentColor" />
    </svg>
  );
}

function ExpertSection({ section, onOpenPdf }) {
  const [expanded, setExpanded] = useState(false);

  const hasMore = section.collapsible && section.items.length > INITIAL_VISIBLE;
  const visibleItems =
    hasMore && !expanded ? section.items.slice(0, INITIAL_VISIBLE) : section.items;

  return (
    <section className="coin-experts-section">
      <div className="coin-experts-section-header">
        <span className="coin-experts-section-bullet" aria-hidden="true">•</span>
        <span className="coin-experts-section-title">{section.title}</span>
      </div>

      <div className="coin-experts-list">
        {visibleItems.map((item, index) => (
          <button
            key={index}
            type="button"
            className={[
              "coin-experts-item",
              item.disabled ? "coin-experts-item--disabled" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            disabled={Boolean(item.disabled)}
            onClick={item.pdfUrl ? () => onOpenPdf(item.pdfUrl) : undefined}
          >
            <span className="coin-experts-item-date">{item.date}</span>
            <span className="coin-experts-item-bar" aria-hidden="true" />
            <span className="coin-experts-item-text">{item.label}</span>
          </button>
        ))}
      </div>

      {hasMore && (
        <div className="coin-experts-show-more">
          <button
            type="button"
            className="coin-experts-arrow-btn"
            onClick={() => setExpanded((v) => !v)}
            aria-label={expanded ? "Réduire la liste" : "Voir plus d'articles"}
            data-tooltip={expanded ? "Voir moins" : "Voir plus"}
          >
            {expanded ? <MinusIcon /> : <PlusIcon />}
          </button>
        </div>
      )}
    </section>
  );
}

function Avis() {
  const history = useHistory();
  const location = useLocation();
  const [currentPdf, setCurrentPdf] = useState(null);

  const resolveFilterKey = (value) => {
    const v = (value || "").toString().trim().toLowerCase();
    if (v === "immobilier") return "immobilier";
    if (v === "divers" || v === "affaires") return "divers";
    return "famille";
  };

  const [activeFilter, setActiveFilter] = useState(() => {
    const queryFilter = new URLSearchParams(location.search).get("filter");
    return resolveFilterKey(queryFilter);
  });

  useEffect(() => {
    const queryFilter = new URLSearchParams(location.search).get("filter");
    setActiveFilter(resolveFilterKey(queryFilter));
  }, [location.search]);

  const trackFilter = (filterKey) => {
    ReactGA.event({ category: "Coin des experts", action: "Changement filtre", label: filterKey });
    setActiveFilter(filterKey);
    history.replace(`/avis?filter=${filterKey}`);
  };

  const handleOpenPdf = (pdfUrl) => {
    setCurrentPdf(pdfUrl);
  };

  const handleClosePdf = () => {
    setCurrentPdf(null);
  };

  const sectionsMap = {
    famille: familySections,
    immobilier: immobilierSections,
    divers: diversSections,
  };

  const activeSections = sectionsMap[activeFilter] || familySections;

  return (
    <div className="coin-experts-page">
      <div className="coin-experts-shell">

        {/* Hero */}
        <header className="coin-experts-hero">
          <h1 className="coin-experts-hero-title">LE COIN DES EXPERTS</h1>
          <p>
            Une question complexe - Une réponse précise - Une mise en application immédiate dans votre pratique
          </p>
          <div className="coin-experts-hero-divider" aria-hidden="true" />
        </header>

        {/* Filtres */}
        <nav
          className="coin-experts-filters"
          role="tablist"
          aria-label="Filtres Le Coin des experts"
        >
          {Object.entries(FILTERS).map(([key, label]) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={activeFilter === key}
              className={`coin-experts-filter${activeFilter === key ? " is-active" : ""}`}
              onClick={() => trackFilter(key)}
            >
              {label}
            </button>
          ))}
        </nav>

        {/* Sections */}
        <div className="coin-experts-sections">
          {activeSections.map((section) => (
            <ExpertSection
              key={section.title}
              section={section}
              onOpenPdf={handleOpenPdf}
            />
          ))}
        </div>
      </div>

      <PdfModal pdfUrl={currentPdf} onClose={handleClosePdf} variant="experts" />
    </div>
  );
}

export default Avis;